import { z } from 'zod';

export type WidgetConfig = {
  hostId: string;
  containerId?: string;
  buttonId?: string;
  floatingButton?: {
    title: string;
    text: string;
  };
  customerInfo?: string;
  customerInfoObject?: CustomerInfoType;
  language?: string;
  currency?: string;
  options?: {
    showListBeforeMap: boolean;
    showFloatingButton: boolean;
  };
};

export type CustomerInfoType = {
  destination?: string;
  name?: string;
  travelers?: TravelerType[] | number;
  eventDate?: Date;
  eventType?: string;
  adults?: number;
  children?: number;
  rooms?: number;
};

export enum TravelerType {
  Adult = 'adult',
  Child = 'child'
}

export const WidgetConfigSchema = z.object({
  hostId: z.string().min(1),
  startComponentSelector: z.string().optional(),
  buttonId: z.string().optional(),
  customerInfo: z.string().optional()
});

export const CustomerInfoSchema = z.object({
  destination: z.string().optional(),
  name: z.string().optional(),
  travelers: z.array(z.string()).nonempty(),
  eventDate: z.string().optional(),
  eventType: z.string().optional()
});
